<template>
  <RouterView />
</template>

<script setup>
import { RouterView } from "vue-router";
</script>

